import React from "react";

const visionPillars = [
  {
    label: "Vision",
    text: "AI that supports real decisions in homes, schools, and care settings",
  },
  {
    label: "Research",
    text: "We examine sound, behavior, and learning patterns with scientific rigor",
  },
  {
    label: "Deployment",
    text: "Every model is shaped into tools families and educators can use quickly",
  },
];

export const About = (props) => {
  const intro =
    props.data?.paragraph ||
    "CradleAI develops child-centered AI tools for family and learning environments.";
  const detail =
    props.data?.detail ||
    "We turn research into practical products that help parents and educators understand key signals earlier and respond with greater confidence.";

  return (
    <section id="about" className="about-section">
      <div className="container about-shell">
        <div className="about-grid">
          <div className="about-copy">
            <p className="section-kicker">About CradleAI</p>
            <h2>AI helps caregivers understand what matters</h2>
            <p className="about-lede">{intro}</p>
            <p className="about-detail">{detail}</p>
          </div>

          <div className="about-visual">
            <div className="about-image-frame">
              <img
                src="img/about.jpg"
                alt="CradleAI education technology and AI research"
              />
            </div>
          </div>
        </div>

        <div className="about-vision-grid">
          {visionPillars.map((pillar) => (
            <article className="about-vision-card" key={pillar.label}>
              <span>{pillar.label}</span>
              <p>{pillar.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
